import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { VerifyEmailUseCase } from '../../../data/repositories/auth/usecases';
import { InputOtpModule } from 'primeng/inputotp';
import { FormFieldComponent } from '../../shared/components/form-field/form-field.component';
import { ButtonModule } from 'primeng/button';
import { VerifyEmailResendUseCase } from '../../../data/repositories/auth/usecases/verify-email-resend.usecase';
import { DialogModule } from 'primeng/dialog';
import { AuthRepositoryQuery } from '../../../domain/repositories/auth.repository';
import {MetaPixelService} from "../../../services/meta-pixel.service";

@Component({
  standalone: true,
  selector: 'app-email-verification',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    DialogModule,
    InputOtpModule,
    FormFieldComponent,
    ButtonModule,
  ],
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.css'],
})
export class EmailVerificationComponent {
  verificationCode: string = '';
  errorMessage: string = '';
  loading: boolean = false;
  resendResultVisible: boolean = false;
  resendModalMessage: string = '';
  resendModalSeverity: 'success' | 'danger' = 'success';
  userEmail = this.authRepositoryQuery.userProfile()?.email || '';

  constructor(
    private authRepositoryQuery: AuthRepositoryQuery,
    private verifyEmailUsecase: VerifyEmailUseCase,
    private verifyEmailResendUsecase: VerifyEmailResendUseCase,
    private router: Router,
    private metaPixel: MetaPixelService
  ) {}

  async onVerify() {
    this.loading = true;
    const result = await this.verifyEmailUsecase.execute({
      code: this.verificationCode,
    });
    if (result.isErr()) {
      const errorResponse = result.getErr();
      this.errorMessage =
        errorResponse?.message ||
        'Невалиден верификационен код или изтекъл токен.';
      this.loading = false;
      return;
    }

    this.metaPixel.track('CompleteRegistration');

    this.router.navigateByUrl('/');
    this.loading = false;
    this.errorMessage = 'Неочаквана грешка. Моля опитайте отново!';
  }
  async onResendVerificationCode() {
    const result = await this.verifyEmailResendUsecase.execute();

    if (result.isErr()) {
      this.resendModalSeverity = 'danger';
      this.resendModalMessage =
        result.getErr()?.message ||
        'Грешка при изпращане на кода. Моля опитайте отново.';
    } else {
      this.resendModalSeverity = 'success';
      this.resendModalMessage =
        'Новият верификационен код беше изпратен успешно.';
    }
    this.resendResultVisible = true;
  }
}
